export type Padding = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 24 | 32 | 44;

export type PaddingMap = {
  [key in Padding]: string;
};

export const paddingMap: PaddingMap = {
  /** 0px */
  0: "p-0",
  /** 4px */
  1: "p-1",
  /** 8px */
  2: "p-2",
  /** 12px */
  3: "p-3",
  /** 16px */
  4: "p-4",
  /** 20px */
  5: "p-5",
  /** 24px */
  6: "p-6",
  /** 28px */
  7: "p-7",
  /** 32px */
  8: "p-8",
  /** 36px */
  9: "p-9",
  /** 40px */
  10: "p-10",
  /** 48px */
  24: "p-24",
  /** 64px */
  32: "p-32",
  /** 176px */
  44: "p-44",
} as const;

export const paddingXMap: PaddingMap = {
  0: "px-0",
  1: "px-1",
  2: "px-2",
  3: "px-3",
  4: "px-4",
  5: "px-5",
  6: "px-6",
  7: "px-7",
  8: "px-8",
  9: "px-9",
  10: "px-10",
  24: "px-24",
  32: "px-32",
  44: "px-44",
} as const;

export const paddingYMap: PaddingMap = {
  0: "py-0",
  1: "py-1",
  2: "py-2",
  3: "py-3",
  4: "py-4",
  5: "py-5",
  6: "py-6",
  7: "py-7",
  8: "py-8",
  9: "py-9",
  10: "py-10",
  24: "py-24",
  32: "py-32",
  44: "py-44",
} as const;

export const paddingTopMap: PaddingMap = {
  0: "pt-0",
  1: "pt-1",
  2: "pt-2",
  3: "pt-3",
  4: "pt-4",
  5: "pt-5",
  6: "pt-6",
  7: "pt-7",
  8: "pt-8",
  9: "pt-9",
  10: "pt-10",
  24: "pt-24",
  32: "pt-32",
  44: "pt-44",
} as const;

export const paddingBottomMap: PaddingMap = {
  0: "pb-0",
  1: "pb-1",
  2: "pb-2",
  3: "pb-3",
  4: "pb-4",
  5: "pb-5",
  6: "pb-6",
  7: "pb-7",
  8: "pb-8",
  9: "pb-9",
  10: "pb-10",
  24: "pb-24",
  32: "pb-32",
  44: "pb-44",
} as const;

export const paddingLeftMap: PaddingMap = {
  0: "pl-0",
  1: "pl-1",
  2: "pl-2",
  3: "pl-3",
  4: "pl-4",
  5: "pl-5",
  6: "pl-6",
  7: "pl-7",
  8: "pl-8",
  9: "pl-9",
  10: "pl-10",
  24: "pl-24",
  32: "pl-32",
  44: "pl-44",
} as const;

export const paddingRightMap: PaddingMap = {
  0: "pr-0",
  1: "pr-1",
  2: "pr-2",
  3: "pr-3",
  4: "pr-4",
  5: "pr-5",
  6: "pr-6",
  7: "pr-7",
  8: "pr-8",
  9: "pr-9",
  10: "pr-10",
  24: "pr-24",
  32: "pr-32",
  44: "pr-44",
} as const;
